export default __webpack_public_path__ + "static/media/marker.e6c41b7f.png";